import { observer } from "mobx-react";
import React, { Component, Fragment } from "react";
import { MainStore } from "../../../stores/MainStore";
import Box from "../../Box";
import Label from "../../Label";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
}
interface IState { }
@observer
class ContinentModalBody extends Component<IProps, IState> {
  render() {
    return (
      <div className={classes.ContinentModalBody}>
        {this.getContinentDetails()}
      </div>
    );
  }

  getContinentDetails() {
    if (!this.props.store) return null;
    const { selectedContinent } = this.props.store;
    return (
      <Fragment>
        <div className={classes.ContinentBodyDetailRow}>
          <div className={classes.ContinentBodyDetailCol}>
            <Box>
              <Label bold small text={selectedContinent.partnerUniversities} />
            </Box>
          </div>
          <div className={classes.ContinentBodyDetailCol}>
            <Label left bold medium id={"modal.continent.partners"} />
            {selectedContinent.doubleDegree && (
              <Fragment>
                <Label left bold small text={"including"} />
                <Label
                  left
                  bold
                  small
                  text={`${selectedContinent.doubleDegree} Double Degree agreements`}
                />
              </Fragment>
            )}
            {selectedContinent.tripleDegree && (
              <Label
                left
                bold
                small
                text={`${selectedContinent.tripleDegree} Triple Degree agreement`}
              />
            )}
          </div>
        </div>
        <div className={classes.ContinentBodyDetailRow}>
          <div className={classes.ContinentBodyDetailCol}>
            <Box>
              <Label bold small text={selectedContinent.studentsExchanged} />
            </Box>
          </div>
          <div className={classes.ContinentBodyDetailCol}>
            <Label left bold medium id={"modal.continent.students"} />
          </div>
        </div>
        <div className={classes.ContinentBodyDetailRow}>
          <div className={classes.ContinentBodyDetailCol}>
            <Box>
              <Label bold small text={selectedContinent.internship} />
            </Box>
          </div>
          <div className={classes.ContinentBodyDetailCol}>
            <Label left bold medium id={"modal.continent.internship"} />
          </div>
        </div>
        {selectedContinent.jobCount === "N/A" ? null : (
          <div className={classes.ContinentBodyDetailRow}>
            <div className={classes.ContinentBodyDetailCol}>
              <Box>
                <Label bold small text={selectedContinent.jobCount} />
              </Box>
            </div>
            <div className={classes.ContinentBodyDetailCol}>
              <Label left bold medium id={"modal.continent.jobs"} />
              {selectedContinent.jobCities && (
                <Label
                  left
                  bold
                  small
                  text={`${selectedContinent.jobCities}`}
                />
              )}
            </div>
            {/* <div className={classes.ContinentBodyDetailColFullSize}>
            <Box className={classes.FullSizeBox}>
              <Label left extraSmall id={"modal.continent.jobs"} />
              <Label bold medium text={selectedContinent.jobCities} />
            </Box>
          </div> */}
          </div>
        )}
        {selectedContinent.inCompanyTraining && (
          <div className={classes.ContinentBodyDetailRow}>
            <div className={classes.ContinentBodyDetailCol}>
              <Box>
                <Label bold small text={selectedContinent.inCompanyTraining} />
              </Box>
            </div>
            <div className={classes.ContinentBodyDetailCol}>
              <Label left bold medium id={"modal.continent.company"} />
            </div>
          </div>
        )}
        {selectedContinent.futureinCompanyTraining && (
          <div className={classes.ContinentBodyDetailRow}>
            <div className={classes.ContinentBodyDetailCol}>
              <Box>
                <Label
                  bold
                  small
                  text={selectedContinent.futureinCompanyTraining}
                />
              </Box>
            </div>
            <div className={classes.ContinentBodyDetailCol}>
              <Label
                left
                bold
                medium
                id={"modal.continent.future-in-company-training"}
              />
            </div>
          </div>
        )}
        <div className={classes.ContinentBodyDetailRow}>
          <div className={classes.ContinentBodyDetailCol}>
            <Box>
              <Label bold small text={selectedContinent.alumni} />
            </Box>
          </div>
          <div className={classes.ContinentBodyDetailCol}>
            <Label left bold medium id={"modal.continent.alumni"} />
          </div>
        </div>
      </Fragment>
    );
  }
}
export default ContinentModalBody;
